import React, { useState, useEffect } from 'react';
import Select from "react-select";
import styled from 'styled-components';
import { Checkbox } from "@fluentui/react";

const Container = styled.div`
  margin-top: 20px;
  padding-top: 10px;
`;

const Title = styled.span`
  top: -10px;
  left: 1.5em;
  background: white;
  padding: 0 5px;
  font-size: 1.2em;
`;

const SelectGroup = styled.div`
  gap: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 95%;
`;

const StyledSelect = styled(Select)`
  margin-bottom: 10px;
  div {
    font-size: 0.99em;
  }
`;


const commandOptions = [
    { value: "switch", label: "Switch" },
];


const moduleNameOptions = [
    { value: "SOURCE-SWITCH", label: "Source Switch" },
    { value: "SLATE-SWITCH", label: "Slate Switch" }
];

const sourceSwitchOptions = [
    { value: "One", label: "One" },
    { value: "Two", label: "Two" },
];

const slateSwitchOptions = [
    { value: "One", label: "One(Stream)" },
    { value: "Two", label: "Two(Slate)" },
];


const DarwinActions = ({ onParamsChange }) => {
    const [darwinParams, setDarwinParams] = useState({
        command: null,
        moduleName: null,
        switchSource: null,
        force: false
    });
    
    const getSwitchOptions = () => {
        if (darwinParams.moduleName === 'SLATE-SWITCH') {
            return slateSwitchOptions;
        }
        return sourceSwitchOptions;
    };

    const handleCommandChange = (selectedOption) => {
        console.log("Selected Darwin command:", selectedOption);
        setDarwinParams(prev => ({
            ...prev,
            command: selectedOption?.value,
            // Reset other values when command changes
            moduleName: null,
            switchSource: null,
            force: false

        }));
    };

    const handleModuleNameChange = (selectedOption) => {
        console.log("Darwin Selected module", selectedOption);
        setDarwinParams(prev => ({
            ...prev,
            moduleName: selectedOption?.value
        }));
    };

    const handleSwitchChange = (selectedOption) => {
        console.log("Darwin Selected Switch source", selectedOption);
        setDarwinParams(prev => ({
            ...prev,
            switchSource: selectedOption?.value
        }));
    };

    const handleForceChange = (ev, checked) => {
        console.log("Force checked:", checked);
        setDarwinParams(prev => ({
            ...prev,
            force: checked
        }));

    };

    useEffect(() => {
        console.log("Updated darwin params:", darwinParams);
        onParamsChange(darwinParams);
        console.log("After Updated darwin params:", darwinParams);
    }, [darwinParams]);

    const isSwitchCommand = darwinParams.command === 'switch' && darwinParams.moduleName
    const currentSwitchOptions = getSwitchOptions();

    return (
        <Container>
            <Title>Darwin Commands</Title>
            <SelectGroup>
                <StyledSelect
                    options={commandOptions}
                    placeholder="Select Command"
                    classNamePrefix="Select"
                    onChange={handleCommandChange}
                    value={commandOptions.find(option => option.value === darwinParams.command) || null}
                />
                <StyledSelect
                    options={moduleNameOptions}
                    placeholder="Select Module"
                    classNamePrefix="Select"
                    onChange={handleModuleNameChange}
                    value={moduleNameOptions.find(option => option.value === darwinParams.moduleName) || null}
                />
                <StyledSelect
                    options={currentSwitchOptions}
                    placeholder="Select Switch source"
                    classNamePrefix="Select"
                    onChange={handleSwitchChange}
                    isDisabled={!isSwitchCommand}
                    value={currentSwitchOptions.find(option => option.value === darwinParams.switchSource) || null}
                />
                <Checkbox 
                    label="Force"
                    checked={darwinParams.force}
                    onChange={handleForceChange}
                    isDisabled={!isSwitchCommand}
                />
            </SelectGroup>
        </Container>
    );
};

export default DarwinActions;
